import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Grid, TextField } from '@mui/material';
import axiosInstance from '../utils/axios'; // Import axios instance

const UserForm = ({ inputEntity, onChange, isDisabled = false, showOrganization = true, showUsername=true, showUserType=true }) => {
    const [entity, setEntity] = useState({ username: '', email: '', first_name: '', last_name: '', organization_id: '', type: '' });
    const [assayProviders, setAssayProviders] = useState(['']);
    const [userTypes, setUserTypes] = useState([
        { id: 'admin', value: 'admin' },
        { id: 'depositor', value: 'depositor' },
        { id: 'reviewer', value: 'reviewer' },
    ]);

    useEffect(() => {
        console.dir("input entity in form:")
        console.dir(inputEntity);
        fetchAssayProviders();

        if (inputEntity != null) {
            setEntity(inputEntity);
        }
    }, [inputEntity]);

    // Fetch AssayProviders
    const fetchAssayProviders = async () => {
        try {
            const response = await axiosInstance.get('/organizations/?organization_type=Assay+Provider');
            setAssayProviders(response.data);
            console.dir("fetch AssayProviders completed...");
        } catch (error) {
            console.error('Error fetching AssayProviders:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedEntity = { ...entity, [name]: value };
        setEntity(updatedEntity);
        onChange(updatedEntity);  // Propagate changes to the parent component
    };

    return (
        <Grid container spacing={2} padding={1}>
            <Grid item xs={3}>
                <FormControl className="styled-form-control" fullWidth>
                    <TextField
                        id="first_name"
                        name="first_name"
                        label="First Name"
                        variant="outlined"
                        fullWidth
                        value={entity.first_name}
                        onChange={handleInputChange}
                        disabled={isDisabled}  // Conditionally disable
                    />
                </FormControl>
            </Grid>
            <Grid item xs={3}>
                <FormControl className="styled-form-control" fullWidth>
                    <TextField
                        id="last_name"
                        name="last_name"
                        label="Last Name"
                        variant="outlined"
                        fullWidth
                        value={entity.last_name}
                        onChange={handleInputChange}
                        disabled={isDisabled}  // Conditionally disable
                    />
                </FormControl>
            </Grid>
            <Grid item xs={6}>
                <FormControl className="styled-form-control" fullWidth>
                    <TextField
                        id="email"
                        name="email"
                        label="Email"
                        variant="outlined"
                        fullWidth
                        value={entity.email}
                        onChange={handleInputChange}
                        disabled={isDisabled}  // Conditionally disable
                    />
                </FormControl>
            </Grid>

            {/* Conditionally show the organization-related fields */}
            {showUsername && (
                <Grid item xs={12}>
                    <FormControl className="styled-form-control" fullWidth>
                        <TextField
                            id="username"
                            name="username"
                            label="Username (Autogenerated)"
                            variant="outlined"
                            fullWidth
                            value={entity.username}
                            onChange={handleInputChange}
                            disabled={isDisabled}  // Conditionally disable
                        />
                    </FormControl>
                </Grid>
            )}

            {showOrganization && (
                <Grid item xs={6}>
                    <FormControl variant="outlined" className="styled-form-control" fullWidth>
                        <InputLabel id="cro-label" shrink>
                            Assay Provider
                        </InputLabel>
                        <Select
                            labelId="organization_id"
                            id="organization_id"
                            name="organization_id"
                            value={entity.organization_id}
                            onChange={handleInputChange}
                            label="Assay Provider"
                            disabled={isDisabled}  // Conditionally disable
                        >
                            <MenuItem value="" disabled>
                                Please select an Assay Provider
                            </MenuItem>
                            {assayProviders.map((cro) => (
                                <MenuItem key={cro.id} value={cro.id}>
                                    {cro.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            )}
            {showUserType && (
                <Grid item xs={6}>
                    <FormControl variant="outlined" className="styled-form-control" fullWidth>
                        <InputLabel id="cro-label" shrink>
                            User Type
                        </InputLabel>
                        <Select
                            labelId="type"
                            id="type"
                            name="type"
                            value={entity.type}
                            onChange={handleInputChange}
                            label="User Type"
                            disabled={isDisabled}  // Conditionally disable
                        >
                            <MenuItem value="" disabled>
                                Please select a User Type
                            </MenuItem>
                            {userTypes.map((type) => (
                                <MenuItem key={type.id} value={type.value}>
                                    {type.value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            )}
        </Grid>
    );
};

export default UserForm;
